export const MIN_TITLE_LENGTH = 3 // Size in chars
export const MAX_TITLE_LENGTH = 40 // Size in chars
export const MIN_DESCRIPTION_LENGTH = 0 // Size in chars
export const MAX_DESCRIPTION_LENGTH = 140 // Size in chars
export const PARCEL_SIZE = 16 // Side size in meters
